import Swal from "sweetalert2";
import CustomAlert from "./CustomAlert";
import { baseUrl } from "./apiList";
import axios from "axios";
import { acquireSlot } from "./apiQueue";

const validateResponse = (apiData) => {
  if (typeof apiData == "undefined") {
    return {
      status: false,
      error: "unauthorized",
    };
  }
  return apiData;
};

const API = axios.create({
  baseURL: baseUrl,
});

// Requests are queued so each one is sent only after the previous response
// has stored its rotated token; the token is read at send time, not call time.
API.interceptors.request.use(async (config) => {
  const { wait, release } = acquireSlot();
  config._releaseSlot = release;
  await wait;

  const token = sessionStorage.getItem("token");
  if (token) config.headers["Authtoken"] = token;

  return config;
});

API.interceptors.response.use(
  (response) => {
    if (response.headers?.authtoken) {
      sessionStorage.setItem("token", response.headers.authtoken);
    }
    response.config?._releaseSlot?.();
    return response;
  },
  (error) => {
    if (error.response?.headers?.authtoken) {
      sessionStorage.setItem("token", error.response.headers.authtoken);
    }
    error.config?._releaseSlot?.();
    return Promise.reject(error);
  }
);

export async function axiosPostApi(url, payload, headers = {}) {
  try {
    const response = await API.post(url, payload, {
      headers: {
        // "Content-Type": "application/json",
        Accept: "application/json",
        ...headers,
      },
    });

    // Log request headers
    // console.log("Request Headers:", response.config.headers["Authtoken"]);
    // console.log("Request Headers 1:", response);

    // Log response headers

    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            sessionStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
            window.location.reload();
          } else if (result.isDenied) {
          }
        })
        .catch((err) => {
          CustomAlert("kk", "kkj");
        });
    }
    return validateResponse(response);
  } catch (error) {
    if (error.response && error.response.status == 401) {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            sessionStorage.clear();
            window.location.href = "/";
          }
        })
        .catch((err) => {
          CustomAlert("kk", "kkj");
        });
    } else if (error.name == "AxiosError") {
      Swal.fire({
        title: "Network Error",
        icon: "error",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } else {
      console.error("Error in postApiData:", error);
      throw error; // Rethrow the error for higher level handling if necessary
    }
  }
}

export async function axiosPostFormData(url, formDataObj, headers = {}) {
  try {
    // Prepare FormData
    const formData = new FormData();
    for (const key in formDataObj) {
      formData.append(key, formDataObj[key]);
    }

    const response = await API.post(url, formData, {
      headers: {
        Accept: "application/json",
        ...headers, // custom headers like auth token
        // DO NOT manually set 'Content-Type' for multipart/form-data
      },
    });


    // Handle session expiration response code
    // if (response.data.respCode === "IS") {
    //   await Swal.fire({
    //     title: "Oops...Session has been expired!!!",
    //     icon: "question",
    //     showDenyButton: false,
    //     showCancelButton: false,
    //     confirmButtonText: "Login Again",
    //     allowOutsideClick: false,
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       sessionStorage.clear();
    //       window.location.href = "/";
    //       window.location.reload();
    //     }
    //   }).catch((err) => {
    //     CustomAlert("Session Error", "Unable to handle session expiration.");
    //   });
    // }

    return validateResponse(response);

  } catch (error) {
    if (error.response && error.response.status === 401) {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      }).catch(() => {
        CustomAlert("Session Error", "Unable to handle session expiration.");
      });
    } else if (error.name === "AxiosError") {
      Swal.fire({
        title: "Network Error",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        sessionStorage.clear();
        window.location.href = "/";
      });
    } else {
      console.error("Error in axiosPostFormData:", error);
      throw error;
    }
  }
}


export async function axiosGetApi(url, headers = {}) {
  try {
    const response = await API.get(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...headers,
      },
    });


    // Handle session expiration
    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            sessionStorage.clear();
            window.location.href = "/";
            window.location.reload();
          }
        })
        .catch((err) => {
          CustomAlert("kk", "kkj");
        });
    }

    // Return the validated response
    return validateResponse(response);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        allowOutsideClick: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            sessionStorage.clear();
            window.location.href = "/";
          }
        })
        .catch((err) => {
          CustomAlert("kk", "kkj");
        });
    } else if (error.name === "AxiosError") {
      Swal.fire({
        title: "Network Error",
        icon: "error",
      });
    } else {
      console.error("Error in axiosGetApi:", error);
      throw error;
    }
  }
}

export async function getApiDataPdf(url, headers) {
  try {
    //const response = await API.get(url,headers);
    const response = await API.get(url, { headers });

    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            sessionStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
            window.location.reload();
          } else if (result.isDenied) {
          }
        })
        .catch((err) => {
          CustomAlert("kk", "kkj");
        });
    }
    return validateResponse(response);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        } else if (result.isDenied) {
        }
      });
      // window.location.href = "/vakrangeeatmadminportal"
    } else {
      // Handle other errors
      console.error("Error in axiosGetApiData:", error);
      throw error; // Rethrow the error for higher level handling if necessary
    }
  }
}

// Downloads a protected file (sends Authtoken) and saves it in the browser.
export async function axiosDownloadFile(url, fileName) {
  const response = await API.get(url, { responseType: "blob" });
  const fileURL = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = fileName || "download";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileURL);
}

export async function postApiDataNew(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
    },
  });
  if (response.headers.authorization) {
    sessionStorage.setItem("token", response.headers?.authorization);
  }
  const apiData = await response.json();
  return validateResponse(apiData);
}

export async function postfileData(url, file, headers) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(url, {
    // mode: 'no-cors',
    method: "POST",
    body: formData,
    // body: JSON.stringify(payload),
    // redirect: 'follow',
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "/",
      type: "formData",
      ...headers,
    },
  });
  const apiData = await response.json();
  return validateResponse(apiData);
}

export async function updateApiData(url, payload) {
  const response = await fetch(url, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  const apiData = await response.json();
  return validateResponse(apiData);
}

export async function axiosDeleteApi(url, payload = {}, headers = {}) {
  try {
    const response = await API.delete(url, {
      data: payload, // IMPORTANT: DELETE body goes inside "data"
      headers: {
        Accept: "application/json",
        ...headers,
      },
    });


    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        confirmButtonText: "Login Again",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    }

    return validateResponse(response);
  } catch (error) {
    console.error("Error in axiosDeleteApi:", error);
    throw error;
  }
}
